module.exports = __webpack_public_path__ + "static/media/IUP_L4.989fc464.svg";